import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.335 8a6.665 6.665 0 1 1 13.33 0 6.665 6.665 0 0 1-13.33 0m6.821-2.409a1.21 1.21 0 0 0-1.348.792.606.606 0 0 1-1.143-.402 2.424 2.424 0 0 1 4.71.808c0 .927-.688 1.54-1.179 1.867a5 5 0 0 1-1.021.514l-.021.007-.007.002-.002.001h-.002a.606.606 0 0 1-.384-1.149l.01-.003.045-.017a3.665 3.665 0 0 0 .71-.364c.418-.278.64-.575.64-.86a1.21 1.21 0 0 0-1.008-1.196m-.762 5.439c0-.335.271-.606.606-.606h.006a.606.606 0 0 1 0 1.212H8a.606.606 0 0 1-.606-.606",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })